import { parseAgrEnvironment } from '@next/core-lib/environment';

import { Environment } from '../../../environments/environment.model';

/**
 * Parse environment variables including custom Field Plan specific variables
 */
export const parseFieldPlanEnvironment = (config: Record<string, string>): Environment => {
  // Parse base AGR environment variables
  const baseEnvironment = parseAgrEnvironment(config);

  // Parse custom Field Plan specific variables
  return {
    ...baseEnvironment,
    AZURE_MAPS_SUBSCRIPTION_KEY: config.AZURE_MAPS_SUBSCRIPTION_KEY || '',
    AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY: config.AZURE_MAPS_SATELLITE_SUBSCRIPTION_KEY || '',
    ENABLE_REGULATORY_MANURE_FIELDS_IMPORT:
      config.ENABLE_REGULATORY_MANURE_FIELDS_IMPORT === 'true',
    ENABLE_MANURE_SPACE: config.ENABLE_MANURE_SPACE === 'true',
    ENABLE_RVO_SYNC: config.ENABLE_RVO_SYNC === 'true',
    SHOW_DEFAULT_CROP_ADVICES_BUTTON: config.SHOW_DEFAULT_CROP_ADVICES_BUTTON === 'true',
    SHOW_GMB_WITH_EIP_REPORT: config.SHOW_GMB_WITH_EIP_REPORT === 'true',
    SHOW_POTATO_CROP_FIELDS_BUTTON: config.SHOW_POTATO_CROP_FIELDS_BUTTON === 'true',
    SHOW_FMS_DIAGNOSE_BUTTON: config.SHOW_FMS_DIAGNOSE_BUTTON === 'true',
    ROUTE_FMS_CUSTOMERS_THROUGH_INTEGRATION:
      config.ROUTE_FMS_CUSTOMERS_THROUGH_INTEGRATION === 'true',
    FIELD_ADVICE_URL: config.FIELD_ADVICE_URL || '',
  };
};
